import classNames from 'clsx';
import { testId } from 'ui-components/services/testid-service';
import { Tooltip } from 'ui-components/components/tooltip';

import { CustomsTextInput } from '../customs-text-input';

import style from './harmonization-code-input.module.css';
import commonStyle from '../common-style.module.less';

type HarmonizationCodeInputProps = {
  onChange: (value: string) => void;
  value?: string;
  'aria-label'?: string;
  className?: string;
  disabled?: boolean;
  disabledReason?: string;
};

const TooltipWrapper = ({
  condition,
  wrapper,
  children,
}: {
  condition: boolean;
  wrapper: (children: React.ReactElement) => React.ReactElement;
  children: React.ReactElement;
}) => (condition ? wrapper(children) : children);

export const HarmonizationCodeInput = ({
  onChange,
  value = '',
  'aria-label': ariaLabel = '',
  className = '',
  disabled = false,
  disabledReason = '',
}: HarmonizationCodeInputProps) => {
  const handleChange = (updatedValue: string | number) => {
    onChange(String(updatedValue));
  };

  return (
    <TooltipWrapper
      condition={disabled && !!disabledReason}
      wrapper={(children: React.ReactElement) => (
        <Tooltip position='top' text={disabledReason}>
          <div className={style['hs-tooltip-wrapper']}>{children}</div>
        </Tooltip>
      )}
    >
      <CustomsTextInput
        {...testId('customs-widget-harmonization-input')}
        aria-label={ariaLabel}
        className={classNames(className, commonStyle['standard-input'])}
        disabled={disabled}
        onChange={handleChange}
        type='text'
        value={value}
      />
    </TooltipWrapper>
  );
};
